import React from 'react';
import { FeeSetConnectionInfo } from '@/types';
import { Trans } from '@lingui/react/macro';

interface FeeSetConnectionInfoDisplayProps {
    value: FeeSetConnectionInfo;
}

const FeeSetConnectionInfoDisplay: React.FC<FeeSetConnectionInfoDisplayProps> = ({ value }) => {
    if (value.feeSetOverridden) {
        return <Trans>Overridden</Trans>;
    }

    return (
        <>
            {value.name}{' '}
            {value.feeSetOutdated ? (
                <>
                    (<Trans>Previous version</Trans>)
                </>
            ) : null}
        </>
    );
};

export default FeeSetConnectionInfoDisplay;
